export const ADMIN_ROLES = {
    SUPER_ADMIN: "super administrator",
    ADMINSTRATOR: "administrator",
    VALIDATOR: "validator"
}

export const REGEX_PATTERNS = {
    // IP Address
    // Four dot-separated octets, each 0–255 (e.g. 192.168.1.1)
    IPV4: /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]\d|\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]\d|\d)){3}$/,

    // Input sanitation / character validation
    // Must contain only digits (0–9), no spaces or other characters
    DIGITS_ONLY: /^\d+$/,
    // Matches any character that is NOT a digit --- used to strip non-numeric chars from code inputs
    NON_DIGITS: /\D/g,
    // Matches any character NOT valid in an IP address (digits, dots, colons for IPv6) — used to sanitize IP input fields
    NON_IP_CHARS: /[^0-9.:]/g,
    // Matches any character NOT valid in a stream endpoint path (e.g. :3002/0/H.264/media.smp) — used to sanitize endpoint input fields
    NON_ENDPOINT_CHARS: /[^a-zA-Z0-9:\/._?=&%]/g,
    // Matches any character that is NOT a letter, digit, or space --- used to strip invalid chars
    ALPHANUMERIC_SPACES: /^[a-zA-Z0-9 ]+$/,
    NON_ALPHANUMERIC_SPACES: /[^a-zA-Z0-9 ]/g,
    // Letters, digits, spaces, and common punctuation: . , - _ @ # ( ) & --- empty string is valid
    GENERAL_INPUT: /^[a-zA-Z0-9 .,\-_@#()&]*$/,
    // Matches any character NOT allowed by GENERAL_INPUT --- used to strip invalid chars
    NON_GENERAL_INPUT: /[^a-zA-Z0-9 .,\-_@#()&]/g,
    // Letters, spaces, hyphens, and apostrophes only --- suitable for person names
    NAME_CHARS: /^[A-Za-z '-]+$/,
    // Letters, spaces, numbers --- For hardware tags
    TAG_CHARS:/^[A-Za-z0-9-]+$/,
    // Matches any character NOT allowed by NAME_CHARS --- used to strip invalid chars from name inputs
    NON_NAME_CHARS: /[^A-Za-z'\-]/g,
    // Must follow the format: localpart@domain.tld (e.g. user@example.com)
    EMAIL: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
    // Matches any character NOT valid in an email address --- used to sanitize email input fields
    NON_EMAIL_CHARS: /[^a-zA-Z0-9._%+\-@]/g,
    // Matches whitespace, hyphens, and parentheses --- used to strip phone number formatting before saving
    PHONE_STRIP_CHARS: /[\s\-\(\)]/g,
    // Captures the R, G, B values from an rgb() or rgba() CSS color string --- used to extract color components
    COLOR_RGB_PARSE: /rgba?\((\d+),\s*(\d+),\s*(\d+)/,

    // Password strength rules
    // Must be at least 15 characters long
    PASSWORD_MIN_LENGTH: /.{15,}/,
    // Must contain at least one uppercase letter (A–Z)
    PASSWORD_UPPERCASE: /[A-Z]/,
    // Must contain at least one lowercase letter (a–z)
    PASSWORD_LOWERCASE: /[a-z]/,
    // Must contain at least one digit (0–9)
    PASSWORD_NUMBER: /[0-9]/,
    // Must contain at least one special character: ! @ # $ % ^ & * ( ) , . ? " : { } | < >
    PASSWORD_SPECIAL_CHAR: /[!@#$%^&*(),.?":{}|<>]/,
}